import { render, staticRenderFns } from "./CourseSidebar.vue?vue&type=template&id=25c6c1e2&scoped=true"
import script from "./CourseSidebar.vue?vue&type=script&lang=js"
export * from "./CourseSidebar.vue?vue&type=script&lang=js"
import style0 from "./CourseSidebar.vue?vue&type=style&index=0&id=25c6c1e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c6c1e2",
  null
  
)

export default component.exports